import { MOT_DE_PASSE_MIN } from './api.js';
/**
 * Code du 401 « mot de passe actuel incorrect ». Distinct de tout code de
 * session : les clients ne tentent PAS de renouveler leur jeton sur ce 401-là —
 * la session est bonne, c'est la saisie qui est fausse. Sans ce code, chaque
 * essai raté coûterait un renouvellement et deux appels au compteur de débit.
 */
export const MOT_DE_PASSE_ACTUEL_INCORRECT_CODE = 'MOT_DE_PASSE_ACTUEL_INCORRECT';
export const MESSAGES_MOT_DE_PASSE = {
    actuelRequis: 'Le mot de passe actuel est requis.',
    actuelIncorrect: 'Le mot de passe actuel est incorrect.',
    tropCourt: `Le nouveau mot de passe doit contenir au moins ${MOT_DE_PASSE_MIN} caractères.`,
    identique: 'Le nouveau mot de passe doit être différent de l’actuel.',
    confirmation: 'La confirmation ne correspond pas au nouveau mot de passe.',
    sessionNip: 'Une session ouverte avec un NIP n’a pas de mot de passe à changer. Le NIP se gère depuis le compte du parent.',
    enrolementRequis: 'La double authentification doit être activée avant de changer le mot de passe.',
    tropDEssais: 'Trop d’essais. Réessayer dans quinze minutes.',
    reseau: 'Connexion impossible. Vérifier la connexion réseau.',
    reussi: 'Mot de passe changé. Les autres appareils connectés à ce compte ont été déconnectés.',
};
/** Les règles, telles que les formulaires les AFFICHENT avant toute saisie. */
export const REGLES_MOT_DE_PASSE = [
    `Au moins ${MOT_DE_PASSE_MIN} caractères.`,
    'Différent du mot de passe actuel.',
    'Les autres appareils connectés seront déconnectés.',
];
/**
 * Ce que le formulaire refuse AVANT d'appeler le serveur — la première faute,
 * ou `null`. Le serveur juge de nouveau : ceci épargne un aller-retour, cela
 * ne remplace rien.
 */
export function verifierChangementMotDePasse(s) {
    if (s.actuel.length === 0)
        return MESSAGES_MOT_DE_PASSE.actuelRequis;
    if (s.nouveau.length < MOT_DE_PASSE_MIN)
        return MESSAGES_MOT_DE_PASSE.tropCourt;
    if (s.nouveau === s.actuel)
        return MESSAGES_MOT_DE_PASSE.identique;
    if (s.nouveau !== s.confirmation)
        return MESSAGES_MOT_DE_PASSE.confirmation;
    return null;
}
/**
 * La phrase à montrer pour un refus du serveur. `erreur` est la forme commune
 * des `ApiError` des deux clients (`status`, `code`, `message`) ; `undefined`
 * pour une panne réseau.
 */
export function messageRefusChangementMotDePasse(erreur) {
    if (!erreur)
        return MESSAGES_MOT_DE_PASSE.reseau;
    if (erreur.code === MOT_DE_PASSE_ACTUEL_INCORRECT_CODE)
        return MESSAGES_MOT_DE_PASSE.actuelIncorrect;
    if (erreur.code === 'MFA_ENROLEMENT_REQUIS')
        return MESSAGES_MOT_DE_PASSE.enrolementRequis;
    if (erreur.status === 429)
        return MESSAGES_MOT_DE_PASSE.tropDEssais;
    if (erreur.status === 403)
        return MESSAGES_MOT_DE_PASSE.sessionNip;
    if (erreur.status === 422) {
        // Le serveur porte une phrase propre (« identique ») ; le refus de forme
        // générique (« Données invalides ») est celui de la règle de longueur.
        return erreur.message && erreur.message !== 'Données invalides'
            ? erreur.message
            : MESSAGES_MOT_DE_PASSE.tropCourt;
    }
    return erreur.message || 'Le mot de passe n’a pas pu être changé.';
}
//# sourceMappingURL=changement-mot-de-passe.js.map